import React from 'react'
import { Card } from "react-bootstrap";

function D2dContent(props) {
    return (
      <>
        <div>
          {props.partnerContent && props.partnerContent.content ? (
            <div 
              dangerouslySetInnerHTML={{
                __html: props.partnerContent.content,
              }}
            ></div>
          ) : (
            <div
              as={"div"}
              dangerouslySetInnerHTML={{
                __html: props.pageContent.content,
              }}
            ></div>
          )}
        </div>
      </>
    );
}

export default D2dContent;